<template>
	<div id="main" class="sheet-page-width mx-auto">
		<div v-show="ajax.sendingCount > 0" id="ajax-throbber"></div>
		<header id="header" class="navbar navbar-dark bg-dark has-title flex-column flex-sm-row align-items-sm-center fixed-top">
			<div class="d-flex align-items-center align-self-start">
				<icon-button name="arrow-back" @click="goBack" class="btn-inverse mr-2 btn-back"
				             :class="appState.backUrl ? '' : 'back-hidden'"></icon-button>
				<div class="navbar-brand">
					<a href="/">{{ domainName }}<span class="text-muted">.net</span></a>
					<small>{{ sheet.name }}</small>
				</div>
			</div>
			<ul class="nav justify-content-between ml-sm-auto">
				<li class="nav-item" v-bind:class="{'active':settingsTabSelected}">
					<router-link class="nav-link text-truncate" to="/settings" v-i18n="'settings_title'"></router-link>
				</li>
				<li class="nav-item" v-bind:class="{'active':expensesTabSelected}">
					<router-link class="nav-link text-truncate" to="/expenses" v-i18n="'expenses_title'"></router-link>
				</li>
				<li class="nav-item" v-bind:class="{'active':debtsTabSelected}">
					<router-link class="nav-link text-truncate" to="/debts" v-i18n="'debts_title'"></router-link>
				</li>
			</ul>
		</header>
		<router-view></router-view>
		<div class="overlay" v-show="changingState"></div>
	</div>
</template>

<script>
	import ajax from 'core/ajax';
	import store from 'core/store';
	import toast from 'ui/toast';
	import IconButton from 'ui/widgets/icon-button.vue';
	import { getDomainName } from 'ui/domain-name';

	export default {
		components: {
			IconButton
		},

		data: function () {
			return {
				ajax,
				sheet: store.globals.sheet,
				changingState: false,
				appState: store.globals.appState,
				domainName: getDomainName()
			}
		},

		computed: {
			settingsTabSelected() {
				return this.$route.path === '/settings';
			},
			expensesTabSelected() {
				return this.$route.path.indexOf('/expenses') !== -1 || this.sheet.isOpen && this.$route.path === '/';
			},
			debtsTabSelected() {
				return this.$route.path === '/debts' || this.sheet.closed && this.$route.path === '/';
			}
		},

		methods: {
			toggleSheetState: function() {
				if (this.sheet.isOpen || confirm(this.$formatMessage('sheet_unlock_confirm'))) {
					this.changingState = true;
					const afterSave = () => {this.changingState = false};
					const sheet = this.sheet.clone();
					sheet.state = Number(!this.sheet.state);
					sheet.update()
							.then(() => {toast.tr(sheet.closed ? 'sheet_lock_saved' : 'sheet_unlock_saved')})
							.then(afterSave, afterSave);
				}
			},
			goBack() {
				this.$router.push(store.globals.appState.backUrl);
			}
		}
	};
</script>

<style lang="scss">
	@import "common";
	@import "~bootstrap/scss/functions";
	@import "~bootstrap/scss/variables";
	@import "~bootstrap/scss/mixins/breakpoints";

	#header {
		.actions button {
			color: rgba(255,255,255,0.5);
			&.active, &:hover {
				color: white;
			}
		}

		button.back-hidden {
			margin-left: -2.3em;
			background: none;
		}

	}

	@include media-breakpoint-down(sm) {
		#header > ul.nav {
			width: 100%;

			.nav-item {
				width: 33%;
				text-align: center;
			}
		}
	}

	body.nav-bar-tabs {
		@include media-breakpoint-up(md) {
			#main {
				margin-top: $header-height + 1rem;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/apps/anonymous/app.vue